module.exports = __webpack_public_path__ + "assets/img/smart.fcb91443.jpg";